module.exports = __webpack_public_path__ + "img/541-15-floor.bed3ac92.jpg";